// src/config/firebase-qa.ts
// QA Firebase Configuration
// This allows admins to test the app with the QA database and seeded test users

// ⚠️ CRITICAL: This must match the actual threadlock-qa Firebase project (403107731211)
// Wrong config causes custom-token-mismatch errors (P4 incident 2026-02-05)
export const QA_FIREBASE_CONFIG = {
  apiKey: 'AIzaSyDYm93MxK3jpxXb4Z3mbwb_ytN3uwM8ipc',
  authDomain: 'threadlock-qa.firebaseapp.com',
  projectId: 'threadlock-qa',
  storageBucket: 'threadlock-qa.firebasestorage.app',
  appId: '1:403107731211:web:41b671b0229b247b63340e',
  messagingSenderId: '403107731211',
} as const;

export const QA_TEST_USERS = {
  // Master Accounts - Comprehensive Testing
  srlPaidMaster: {
    email: 'srl.paid.master@test.threadlock.ai',
    password: 'Test@123!',
    persona: 'SRL',
    plan: 'Paid',
    status: 'Active',
    jurisdiction: 'California',
    description: 'Self-represented litigant with active paid subscription',
  },
  srlFreeMaster: {
    email: 'srl.free.master@test.threadlock.ai',
    password: 'Test@123!',
    persona: 'SRL',
    plan: 'Free',
    status: 'Trial',
    jurisdiction: 'California',
    description: 'Self-represented litigant on free trial',
  },
  srlLapsedMaster: {
    email: 'srl.lapsed.master@test.threadlock.ai',
    password: 'Test@123!',
    persona: 'SRL',
    plan: 'Paid',
    status: 'Lapsed',
    jurisdiction: 'California',
    description: 'Self-represented litigant with lapsed subscription',
  },
  legalProPaidMaster: {
    email: 'legalpro.pro.master@test.threadlock.ai',
    password: 'Test@123!',
    persona: 'Legal Pro',
    plan: 'Pro',
    status: 'Active',
    jurisdiction: 'California',
    description: 'Legal professional with active pro subscription',
  },
  legalProTrialMaster: {
    email: 'legalpro.trial.master@test.threadlock.ai',
    password: 'Test@123!',
    persona: 'Legal Pro',
    plan: 'Pro',
    status: 'Trial',
    jurisdiction: 'California',
    description: 'Legal professional on pro trial',
  },
  legalProInvited: {
    email: 'legalpro.invited@test.threadlock.ai',
    password: 'Test@123!',
    persona: 'Legal Pro',
    plan: 'N/A',
    status: 'N/A',
    jurisdiction: 'California',
    description: 'Legal professional invited to a case',
  },
  reviewerPool: {
    email: 'reviewer.pool@test.threadlock.ai',
    password: 'Test@123!',
    persona: 'Reviewer',
    plan: 'N/A',
    status: 'N/A',
    jurisdiction: 'N/A',
    description: 'Professional reviewer in the marketplace pool',
  },
  admin: {
    email: 'admin@test.threadlock.ai',
    password: 'Test@123!',
    persona: 'Admin',
    plan: 'N/A',
    status: 'N/A',
    jurisdiction: 'N/A',
    description: 'Platform administrator',
  },
} as const;

// Jurisdiction-specific test users (generated from seed script)
export const US_JURISDICTIONS = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 
  'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 
  'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 
  'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 
  'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 
  'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 
  'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming', 'District of Columbia', 'Federal'
] as const;

/**
 * Generate jurisdiction-specific user email
 * Example: getJurisdictionUserEmail('California') → 'srl.paid.california@test.threadlock.ai'
 */
export function getJurisdictionUserEmail(jurisdiction: string): string {
  const sanitized = jurisdiction.toLowerCase().replace(/\s+/g, '_').replace(/[.]/g, '');
  return `srl.paid.${sanitized}@test.threadlock.ai`;
}

/**
 * Check if currently using QA Firebase
 */
export function isQAEnvironment(): boolean {
  if (typeof window === 'undefined') return false;
  return sessionStorage.getItem('qa_mode') === 'true';
}

/**
 * Enable QA mode (switches to QA Firebase)
 */
export function enableQAMode(): void {
  sessionStorage.setItem('qa_mode', 'true');
  sessionStorage.setItem('qa_switched_at', new Date().toISOString());
}

/**
 * Disable QA mode (switches back to production Firebase)
 */
export function disableQAMode(): void {
  sessionStorage.removeItem('qa_mode');
  sessionStorage.removeItem('qa_switched_at');
}
